import React, { useState } from 'react';
import { motion } from "framer-motion";
import "../css/turnoNuevo.css";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Button } from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import TurnoPDF from './TurnoPDF';

function NuevoTurno(props) {

  const [datosTurno, setDatosTurno] = useState({dni: 0, email: ""});
  const [pidioPDF, setPidioPDF] = useState(false);
  
  
  return (
    <motion.div 
      className='gestor-turno'
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.8 }} >

        <div className='container-turno'>
            <div className='turno-titulo'>
                <Button color='success' style={{"pointer-events": "none"}}><CheckCircleOutlineIcon style={{"minWidth": "50", "width": "70", "height": "70"}} /></Button>
                <p> El turno fue guardado exitosamente </p>
            </div>

            <div style={{"display": "flex", "flexDirection":"column"}}>
                <div className='turno-campo'>
                    <p className='label-turno'> Nombre:</p>
                    <p className='contenido-turno'>{props.nombre}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> DNI:</p>
                    <p className='contenido-turno'>{props.dni}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> N° de turno:</p>
                    <p className='contenido-turno'>{props.codigo}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Fecha:</p>
                    <p className='contenido-turno'>{props.fecha}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Hora:</p>
                    <p className='contenido-turno'>{props.hora}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Lugar:</p>
                    <p className='contenido-turno'>{props.lugar}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Módulo:</p>
                    <p className='contenido-turno'>{props.modulo}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Dependencia:</p>
                    <p className='contenido-turno'>{props.dependencia}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Servicio:</p>
                    <p className='contenido-turno'>{props.servicio.nombre}</p>
                </div>
                <hr/>
            </div>
            <div className='cont-boton'>
            <Button 
                    sx={{height: 60}}
                    variant='contained' 
                    type='button' 
                    color='secondary'
                    className='boton-gestion-turno'
                    endIcon={<ArrowCircleDownIcon/>}
                    onClick={() => {
                      if(pidioPDF){
                        setPidioPDF(false);
                      }
                      else setPidioPDF(true);

                    }}>DESCARGAR PDF</Button>
          </div>
            <div className='cont-boton'>
            <Button 
                    variant='contained' 
                    type='button' 
                    color='secondary'
                    className='boton-gestion-turno'
                    href='/nuevaturnera'
                    onClick={() => {
                    }}>NUEVO TURNO</Button>
          </div>

          <p className='letra-chica'>
            No es necesario imprimir el turno generado. <br/>
            Hemos enviado un email a tu casilla de correo electrónico con los datos del turno.
          </p>
        </div>
    
        {pidioPDF && <TurnoPDF codigo={props.codigo} fecha={props.fecha} hora={props.hora} lugar={props.lugar} servicio={props.servicio.nombre} />}
      
    </motion.div>
  );
}

export default NuevoTurno;
